// extracted by mini-css-extract-plugin
export default {"subfooter":"SubFooter_subfooter__v6gVM"};